import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
import DataTable, { defaultThemes } from "react-data-table-component";
import NumberFormat from "react-number-format";
const ScrollDataTable = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { R_dataTable, R_joripara, R_wasl, R_del_dis, DeleteSail } =
            value;
          const datas = R_dataTable.reverse().map((el) => {
            return {
              name: el.nawisht,
              nrx: el.nrx,
              zhmara: el.raqam,
              darzan: el.darzan,
              carton: el.carton,
              koygshty: (
                <div>
                  {R_joripara == "دۆلار" ? (
                    <NumberFormat
                      value={el.kodolar}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  ) : (
                    <NumberFormat
                      value={el.kodinar}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  )}
                </div>
              ),
              delete: (
                <button
                  onClick={() => DeleteSail(el._id, el, R_wasl)}
                  disabled={R_del_dis == true ? true : null}
                  className="btn btn-danger "
                >
                  <i className="fa fa-minus" aria-hidden="true"></i>
                </button>
              )
            };
          });
          const columns = [
            {
              name: "کۆی گشتی",
              selector: "koygshty",
              sortable: true,
              center: true
            },
            {
              name: "نرخ",
              selector: "nrx",
              sortable: true,
              center: true
            },
            {
              name: "دەرزەن",
              selector: "darzan",
              sortable: true,
              center: true
            },
            {
              name: "کارتۆن",
              selector: "carton",
              sortable: true,
              center: true
            },
            {
              name: "ناوی شت",
              selector: "name",
              sortable: true,
              center: true
            },
            {
              name: "کۆد",
              selector: "zhmara",
              sortable: true,
              center: true
            },
            {
              name: "X",
              selector: "delete",
              sortable: true,
              center: true
            }
          ];
          const customStyles = {
            rows: {
              style: {
                fontSize: "16px",
                borderTopColor: defaultThemes.default.divider.default,
                borderTopWidth: "1px"
              }
            },
            headCells: {
              style: {
                fontSize: "18px",
                minHeight: "70px",
                "&:not(:last-of-type)": {
                  borderRightStyle: "solid",
                  borderRightWidth: "1px",
                  borderRightColor: defaultThemes.default.divider.default
                }
              }
            },
            cells: {
              style: {
                fontSize: "18px",
                padding: "0px",
                "&:not(:last-of-type)": {
                  borderRightStyle: "solid",
                  borderRightWidth: "1px",
                  borderRightColor: defaultThemes.default.divider.default
                }
              }
            }
          };

          // const customStyles = {
          //   header: {
          //     style: {
          //       minHeight: '56px',
          //       background:"#2C3539"
          //     },

          //   },
          //   headRow: {
          //     style: {
          //       borderTopStyle: 'solid',
          //       borderTopWidth: '1px',
          //       borderTopColor: defaultThemes.default.divider.default,
          //       background:"#2C3539",
          //     },
          //   },
          //   headCells: {
          //     style: {
          //       '&:not(:last-of-type)': {
          //         borderRightStyle: 'solid',
          //         borderRightWidth: '1px',
          //         borderRightColor: defaultThemes.default.divider.default,
          //       },
          //       color:"#f0ad4e",
          //       fontSize:"18px",
          //      minHeight: '70px',
          //     },
          //   },
          //   cells: {
          //     style: {
          //       '&:not(:last-of-type)': {
          //         borderRightStyle: 'solid',
          //         borderRightWidth: '1px',
          //         borderRightColor: defaultThemes.default.divider.default,
          //       },
          //       fontSize:"18px"
          //     },
          //   },
          // };

          return (
            <>
              <div className="card-header p-1 border-bottom border-warning">
                <DataTable
                  columns={columns}
                  data={datas}
                  noDataComponent={"هیچ کاڵایەک نیە"}
                  className="fk f1"
                  customStyles={customStyles}
                  dense
                />
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};
export default ScrollDataTable;
